import Image from "@Components/Image";
import CustomLink from "@Components/CustomLink";
import config from "@Config/index";
import {
  APP_DOWNLOAD_APP_STORE_IMG,
  APP_DOWNLOAD_APP_STORE_LINK,
  APP_DOWNLOAD_PLAY_STORE_IMG,
  APP_DOWNLOAD_PLAY_STORE_LINK,
  APP_DOWNLOAD_QR_NAVBAR,
  PAGE,
} from "constants/configConstants";
import styles from "./DownloadApp.module.scss";

export const data = [
  {
    icon: "verified",
    boldText: "100%",
    text: "Verified Listings",
  },
  {
    icon: "easy-booking",
    boldText: "Quick and Easy",
    text: "Bookings",
  },
  {
    icon: "tagGreen",
    boldText: "Price Match",
    text: "Guarantee",
  },
  {
    icon: "message-smile",
    boldText: "24x7",
    text: "Personal Assistance",
  },
];

const DownloadApp = ({ parentPage = PAGE.HOME }: { parentPage: string }) => {
  const appDownloadQR = APP_DOWNLOAD_QR_NAVBAR[parentPage || PAGE.HOME];

  return (
    <div className={styles.container}>
      <div className={styles.headingSection}>
        <h3>Start your journey from here!</h3>
        <p className={styles.details}>More than 1.25 million beds available in 600 cities</p>
      </div>
      <div className={styles.contentSection}>
        <div className={styles.QRWrap}>
          <p className={styles.qr}>
            Scan The <strong>QR</strong> to download the App
          </p>
          <Image
            className={styles.qrImg}
            src={appDownloadQR}
            alt="app QR"
            height={180}
            width={180}
            noTransformAnimation
          />
          <p>You can directly download from</p>
          <div className={styles.appLinks}>
            <CustomLink target="_blank" rel="noreferrer" href={APP_DOWNLOAD_PLAY_STORE_LINK}>
              <Image
                src={APP_DOWNLOAD_PLAY_STORE_IMG}
                alt="play store"
                width={131}
                height={39}
                noTransformAnimation
              />
            </CustomLink>
            <CustomLink target="_blank" rel="noreferrer" href={APP_DOWNLOAD_APP_STORE_LINK}>
              <Image
                src={APP_DOWNLOAD_APP_STORE_IMG}
                alt="app store"
                width={131}
                height={39}
                noTransformAnimation
              />
            </CustomLink>
          </div>
        </div>
        <div className={styles.uspWrap}>
          {data.map((it) => (
            <div className={styles.uspItem} key={it.icon}>
              <Image
                src={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/${it.icon}.svg`}
                alt={it.icon}
                width={20}
                height={20}
                noTransformAnimation
              />
              <p>
                <b>{it.boldText}</b> {it.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default DownloadApp;
